import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Divider, Typography } from 'antd';
import { UserOutlined, MobileOutlined } from '@ant-design/icons';
import { publicAPI } from '../services/api';

const { Text } = Typography;

function ClientLogin() {
  const [loading, setLoading] = useState(false);
  const [loginResult, setLoginResult] = useState(null);

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      console.log('登录请求参数:', values);
      
      // 调用后台登录接口
      const response = await publicAPI.clientLogin({
        authKey: values.username,
        channel: values.channel || 'admin',
        countryCode: 'CN',
        deviceId: values.deviceId || 'admin-device-' + Date.now(),
        deviceModel: 'Web Admin',
        clientVersion: '1.0.0',
        language: 1,
        appName: 'Doomsday Admin'
      });

      console.log('登录响应:', response.data);

      if (response.data.success) {
        message.success('登录成功！');
        setLoginResult(response.data.data);
      } else {
        message.error('登录失败：' + (response.data.message || '未知错误'));
        setLoginResult(response.data);
      }
    } catch (error) {
      console.error('登录错误:', error);
      message.error('登录失败：' + (error.response?.data?.message || error.message));
      setLoginResult({
        success: false,
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGetRecommendServer = async () => {
    try {
      const response = await publicAPI.getRecommendServer({
        authKey: loginResult?.userId || 'test'
      });

      if (response.data.success) {
        message.success('获取推荐服务器成功');
        console.log('推荐服务器:', response.data.data);
      } else {
        message.error('获取推荐服务器失败');
      }
    } catch (error) {
      message.error('获取推荐服务器失败：' + error.message);
    }
  };

  return (
    <div className="standalone-page">
      <div className="standalone-shell">
        <div className="page-header">
          <div className="page-header-main">
            <div className="page-title">客户端登录测试</div>
            <div className="page-subtitle">保留原有登录调试逻辑，只替换掉原来的旧式测试页面布局。</div>
          </div>
        </div>

        <div className="page-note">
          <div className="page-note-text">
            <span className="page-note-strong">用于验证客户端登录链路和推荐服接口。</span>
            适合快速测试账号、渠道和设备标识，不参与后台主流程。
          </div>
          <Text type="secondary">调试页</Text>
        </div>

        <Card title="登录请求" className="section-card">
        <Form
          name="client_login"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            label="账号"
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="请输入账号" />
          </Form.Item>

          <Form.Item
            name="channel"
            label="渠道"
            initialValue="admin"
          >
            <Input placeholder="请输入渠道，默认 admin" />
          </Form.Item>

          <Form.Item
            name="deviceId"
            label="设备 ID"
          >
            <Input prefix={<MobileOutlined />} placeholder="设备 ID（可选）" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              发起登录请求
            </Button>
          </Form.Item>
        </Form>
        </Card>

        {loginResult && (
          <Card title="接口返回" className="table-card" extra={loginResult.userId ? <Button onClick={handleGetRecommendServer}>获取推荐服务器</Button> : null}>
            <Divider />
            <div className="selection-panel">
              <div className="selection-panel-head">
                <div>
                  <div className="selection-panel-title">登录结果</div>
                  <div className="selection-panel-subtitle">保留原始返回结构，便于直接复制和比对。</div>
                </div>
              </div>
              <pre style={{
                margin: 0,
                background: '#f4f6f8',
                padding: 18,
                borderRadius: 16,
                border: '1px solid #d9dfe8',
                maxHeight: 420,
                overflow: 'auto'
              }}>
                {JSON.stringify(loginResult, null, 2)}
              </pre>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}

export default ClientLogin;
